/**
 * True only for a hover-capable pointer.
 *
 * Magnetic and Tilt use this to decide whether to exist at all. On a touch
 * device there is no cursor to lean toward, so they must attach nothing rather
 * than merely look static.
 */
import { useEffect, useState } from "react";

const QUERY = "(pointer: fine)";

export function useFinePointer(): boolean {
  const [fine, setFine] = useState<boolean>(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia(QUERY);
    const onChange = () => setFine(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return fine;
}
